(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // Keep content from jumping under fixed header by syncing spacer height
    const headerEl = document.querySelector('.site-header');
    const headerSpacer = document.getElementById('site-header-spacer');
    const headerBackdrop = document.querySelector('.site-header-backdrop');
    const setHeaderSpacer = () => {
      if (!headerEl || !headerSpacer) return;
      const rect = headerEl.getBoundingClientRect();
      const computed = getComputedStyle(headerEl);
      const padTop = parseFloat(computed.paddingTop) || 0;
      const padBottom = parseFloat(computed.paddingBottom) || 0;
      const height = rect.height; // already includes paddings
      headerSpacer.style.setProperty('height', `${height}px`);
      document.documentElement.style.setProperty('--site-header-height', `${height}px`);
      if (headerBackdrop) headerBackdrop.style.height = `${height}px`;
    };
    setHeaderSpacer();
    window.addEventListener('resize', () => {
      setHeaderSpacer();
    });
    // Toggle per-element contrast depending on media underneath the header.
    // We'll use CSS `filter` on the logo instead of swapping `src` to avoid
    // loading/switching image assets.

    // Per-element detection: sample the point just below the header at the
    // horizontal center of each interactive element and toggle a class on
    // that element only when the area below it contains an image or
    // background-image. This allows switching only the logo, or only a
    // specific link, rather than the whole header.
    const announcementHeight = () => parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--announcement-height')) || 46;
    const headerHeight = () => parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--site-header-height')) || (headerEl ? headerEl.getBoundingClientRect().height : 0);

    // More conservative media detection:
    // - For IMG nodes require either an ancestor with theme full-width classes
    //   or that the image height is a significant portion of the viewport.
    // - For background-image require a non-gradient background and prefer
    //   nodes with theme full-width classes.
    const isLightColor = (colorStr) => {
      // colorStr e.g. 'rgb(255, 255, 255)' or 'rgba(...)' or 'transparent'
      if (!colorStr || colorStr === 'transparent') return false;
      const m = colorStr.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/i);
      if (!m) return false;
      const r = parseInt(m[1], 10), g = parseInt(m[2], 10), b = parseInt(m[3], 10);
      // Relative luminance (simple) — normalize to 0..1
      const lum = (0.2126 * r + 0.7152 * g + 0.0722 * b) / 255;
      return lum > 0.9; // too light -> treat as not a media background
    };

    const detectMediaAt = (x, y) => {
      if (y > window.innerHeight || x < 0 || x > window.innerWidth) return false;
      const el = document.elementFromPoint(x, y);
      if (!el) return false;

      // If the element itself is a theme full-width image container, accept
      const candidate = el.closest('.full-width-image-container, .full-width-image, .fullscreen-slide, .full-width-images-section, .hero-editorial, .hero-editorial-section');
      if (candidate) return true;

      // Walk ancestors for IMG/background checks
      let node = el;
      while (node && node !== document.documentElement) {
        if (node.tagName === 'IMG') {
          const imgRect = node.getBoundingClientRect();
          // Require image to cover a decent chunk of the viewport height
          if (imgRect.height >= (window.innerHeight * 0.3)) return true;
          // Also accept if image is explicitly inside a full-width container
          if (node.closest('.full-width-image-container, .fullscreen-slide, .hero-editorial, .hero-editorial-section')) return true;
        }

        const bg = getComputedStyle(node).backgroundImage || '';
        const bgColor = getComputedStyle(node).backgroundColor || '';
        if (bg && bg !== 'none' && bg.indexOf('gradient') === -1) {
          if (!isLightColor(bgColor)) return true;
          // If background is light color, don't treat as media
        }

        node = node.parentElement;
      }
      return false;
    };

    const logoEl = headerEl.querySelector('.header-logo');
    const menuLinks = Array.from(headerEl.querySelectorAll('.header-menu-link'));
    // Include search toggle and cart so each action can invert individually
    const actions = Array.from(headerEl.querySelectorAll('.header-action'));

    const samplePointsForElement = (el) => {
      const rect = el.getBoundingClientRect();
      const y = Math.round(announcementHeight() + headerHeight() + 2);
      // sample 3 horizontal positions: left third, center, right third
      const p1 = { x: Math.round(rect.left + rect.width * 0.25), y };
      const p2 = { x: Math.round(rect.left + rect.width * 0.5), y };
      const p3 = { x: Math.round(rect.left + rect.width * 0.75), y };
      return [p1, p2, p3];
    };

    const majorityTrue = (arr) => arr.filter(Boolean).length >= 2;

    const updatePerElementContrast = () => {
      // Logo: apply by default
      if (logoEl) {
        const points = samplePointsForElement(logoEl);
        const results = points.map(p => detectMediaAt(p.x, p.y));
        logoEl.classList.toggle('is-over-media', majorityTrue(results));
      }

      // Menu links: toggle class individually using majority sampling
      menuLinks.forEach((link) => {
        const points = samplePointsForElement(link);
        const results = points.map(p => detectMediaAt(p.x, p.y));
        link.classList.toggle('is-over-media', majorityTrue(results));
      });

      // Actions (icons/buttons)
      actions.forEach((act) => {
        const points = samplePointsForElement(act);
        const results = points.map(p => detectMediaAt(p.x, p.y));
        act.classList.toggle('is-over-media', majorityTrue(results));
      });
    };

    let ticking = false;
    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(() => { updatePerElementContrast(); ticking = false; });
        ticking = true;
      }
    }, { passive: true });
    window.addEventListener('resize', updatePerElementContrast);
    // run initially after spacer calculated
    updatePerElementContrast();
    const cartToggle = document.getElementById('cart-toggle');
    const cartSidebar = document.getElementById('cart-sidebar');
    const cartOverlay = document.getElementById('cart-overlay');
    const cartClose = document.getElementById('cart-close');
    const cartItems = document.getElementById('cart-items');
    const cartCount = document.getElementById('cart-count');
    const mobileCartCount = document.getElementById('mobile-cart-count');
    const cartTotal = document.getElementById('cart-total');
    const bundleProductId = String(cartSidebar.dataset.bundleProductId || '');
    const bundleProductHandle = String(cartSidebar.dataset.bundleProductHandle || '');
    const bundleImageUrls = [cartSidebar.dataset.bundleImagePrimary, cartSidebar.dataset.bundleImageSecondary].filter(Boolean);

    function cartItemImage(item) {
      const isBundle = (bundleProductId && String(item.product_id) === bundleProductId) ||
                       (bundleProductHandle && item.handle === bundleProductHandle);
      if (isBundle && bundleImageUrls.length) {
        return `<span class="bundle-cart-images" aria-hidden="true">${bundleImageUrls.map((url) => `<img src="${url}" alt="" loading="lazy" width="80" height="80">`).join('')}</span>`;
      }
      if (item.featured_image && item.featured_image.url) {
        return `<img src="${item.featured_image.url}?width=160" alt="${item.product_title}" loading="lazy" width="80" height="80">`;
      }
      return '<div class="no-image">No Image</div>';
    }
    // Localized option labels mapping via themeStrings (set in layout)
    const translateOptionName = (name) => {
      if (!name) return '';
      const key = String(name).trim().toLowerCase();
      if (key === 'size' || key === 'tamanho') return window.themeStrings?.option_size_label || name;
      if (key === 'color' || key === 'cor') return window.themeStrings?.option_color_label || name;
      return name;
    };
    const escapeHtml = (value) => String(value ?? '').replace(/[&<>"']/g, (character) => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
    })[character]);

    // Store current cart data for stock validation
    let currentCartData = null;
    let currentInventoryData = {};

    // Predictive Search
    const searchInput = document.getElementById('header-search-input');
    const searchResults = document.getElementById('predictive-search-results');
    let searchTimeout;

    if (searchInput && searchResults) {
      searchInput.addEventListener('input', function() {
        clearTimeout(searchTimeout);
        const query = this.value.trim();

        if (query.length === 0) {
          searchResults.innerHTML = '';
          searchResults.classList.remove('has-results');
          return;
        }

        searchTimeout = setTimeout(() => {
          fetch(`${cartEndpoint('search/suggest.json')}?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=5`)
            .then(response => response.json())
            .then(data => {
              const products = data.resources.results.products;
              
              if (products.length > 0) {
                searchResults.innerHTML = products.map(product => `
                  <a href="${product.url}" class="predictive-search-item">
                    <img src="${product.image}" alt="${product.title}" class="predictive-search-image" width="40" height="40">
                    <div class="predictive-search-info">
                      <h4 class="predictive-search-title">${product.title}</h4>
                      <div class="predictive-search-price">
                        ${product.available ? formatCartMoney(product.price, window.themeMoney?.currency) : '<span class="sold-out-badge">Sold Out</span>'}
                      </div>
                    </div>
                  </a>
                `).join('');
                searchResults.classList.add('has-results');
              } else {
                searchResults.innerHTML = '<div class="predictive-search-item">No results found</div>';
                searchResults.classList.add('has-results');
              }
            })
            .catch(error => {
              console.error('Error fetching search suggestions:', error);
            });
        }, 300); // Debounce for 300ms
      });

      // Close search results when clicking outside
      document.addEventListener('click', function(event) {
        if (!searchInput.contains(event.target) && !searchResults.contains(event.target)) {
          searchResults.classList.remove('has-results');
        }
      });
    }

    // Open cart sidebar
    function openCart() {
      cartSidebar.classList.add('open');
      cartOverlay.classList.add('open');
      document.body.style.overflow = 'hidden';
      loadCartItems();
    }

    // Close cart sidebar
    function closeCart() {
      cartSidebar.classList.remove('open');
      cartOverlay.classList.remove('open');
      document.body.style.overflow = '';
    }

    // Event listeners
    cartToggle.addEventListener('click', function (e) {
      e.preventDefault();

      if (document.body.dataset.template === 'cart') {
        return;
      }
      openCart();
    });

    const mobileCartToggle = document.getElementById('mobile-cart-toggle');
    if (mobileCartToggle) {
      mobileCartToggle.addEventListener('click', function (e) {
        e.preventDefault();
        closeMobileNav(); // Close mobile nav first
        openCart();
      });
    }

    cartClose.addEventListener('click', closeCart);
    cartOverlay.addEventListener('click', closeCart);

    // Load cart items via AJAX
    function loadCartItems() {
      // Fetch both cart data and inventory data
      Promise.all([
        fetch(cartEndpoint('cart.js')).then(res => {
          if (!res.ok) throw new Error('Unable to load cart');
          return res.json();
        }),
        fetch(cartEndpoint('?section_id=cart-inventory')).then(res => {
          if (!res.ok) throw new Error('Unable to load inventory');
          return res.text();
        })
      ])
      .then(([cart, inventoryHtml]) => {
        // Parse inventory data from the section HTML
        const parser = new DOMParser();
        const doc = parser.parseFromString(inventoryHtml, 'text/html');
        const inventoryJson = doc.getElementById('inventory-data')?.textContent;
        
        if (inventoryJson) {
          try {
            const data = JSON.parse(inventoryJson);
            currentInventoryData = data.items || {};
          } catch (e) {
            console.error('Error parsing inventory data', e);
            currentInventoryData = {};
          }
        }

        // Store cart data for stock validation
        currentCartData = cart;

        renderCartItems(cart);
        updateCartCount(cart.item_count);
        updateCartTotal(cart);
      })
      .catch((error) => {
        console.error('Error loading cart:', error);
      });
    }

    // Mobile nav toggle
    const mobileNavToggle = document.getElementById('mobile-nav-toggle');
    const mobileNav = document.getElementById('mobile-nav');
    const mobileNavOverlay = document.getElementById('mobile-nav-overlay');
    const mobileNavClose = document.getElementById('mobile-nav-close');
    const headerLogoImg = document.querySelector('.header-logo');
    const mobileLogoSrc = 'https://cdn.shopify.com/s/files/1/0954/9840/4181/files/Logo_black.svg?v=1764257555';
    const originalLogoSrc = headerLogoImg ? headerLogoImg.getAttribute('src') : null;

    function openMobileNav() {
      if (!mobileNav || !mobileNavOverlay) return;
      mobileNav.classList.add('open');
      mobileNavOverlay.classList.add('open');
      document.body.style.overflow = 'hidden';
    }

    function closeMobileNav() {
      if (!mobileNav || !mobileNavOverlay) return;
      mobileNav.classList.remove('open');
      mobileNavOverlay.classList.remove('open');
      document.body.style.overflow = '';
    }

    if (mobileNavToggle) mobileNavToggle.addEventListener('click', function (e) {
      e.preventDefault();
      openMobileNav();
    });
    if (mobileNavClose) mobileNavClose.addEventListener('click', closeMobileNav);
    if (mobileNavOverlay) mobileNavOverlay.addEventListener('click', closeMobileNav);

    // Render cart items
    function renderCartItems(cart) {
      // Store cart data for stock validation
      currentCartData = cart;

      if (cart.items.length === 0) {
        cartItems.innerHTML = `
        <div class="cart-empty">
          <p>${window.themeStrings?.cart_empty_title || 'Your cart is empty'}</p>
        </div>
      `;
        return;
      }

      cartItems.innerHTML = cart.items
        .map((item) => {
          // Build translated variant string from options
          let variantHtml = '';
          const opts = Array.isArray(item.options_with_values) ? item.options_with_values : [];
          const nonDefault = !(opts.length === 1 && String(opts[0]?.name || '').toLowerCase() === 'title');
          
          if (opts.length && nonDefault) {
            const parts = opts.map((ov) => {
              let optClass = 'variant-option';
              const optNameDown = ov.name.toLowerCase();
              if (optNameDown.includes('size') || optNameDown.includes('tamanho')) {
                optClass = 'size-badge';
              }
              return `<span class="${optClass}">${translateOptionName(ov.name)}: ${ov.value}</span>`;
            });
            const isBundle = String(item.product_id) === bundleProductId || item.handle === bundleProductHandle;
            variantHtml = `<div class="item-variant${isBundle ? ' item-variant--bundle' : ''}">${parts.join('')}</div>`;
          }

          // Get inventory data for this item
          const inventoryItem = currentInventoryData[item.key];
          
          const hasInventoryLimit = 
            inventoryItem &&
            inventoryItem.inventory_management === 'shopify' &&
            inventoryItem.inventory_policy === 'deny' &&
            inventoryItem.inventory_quantity !== null;
            
          const availableStock = hasInventoryLimit ? inventoryItem.inventory_quantity : null;
          const isMaxQuantity = hasInventoryLimit && item.quantity >= availableStock;
          const originalPrice = Number(item.original_price ?? item.price ?? 0);
          const originalLinePrice = Number(item.original_line_price ?? originalPrice * item.quantity);

          return `
      <div class="cart-item-card" data-key="${item.key}">
        <div class="item-image">
          <a href="${item.url}" style="display: block; width: 100%; height: 100%;">
            ${cartItemImage(item)}
          </a>
        </div>

        <div class="item-info">
          <a href="${item.url}" style="text-decoration: none; color: inherit;">
            <h3 class="item-title">${item.product_title}</h3>
          </a>
          
          <div class="item-variant-price-wrapper">
            ${variantHtml}
            <span class="variant-price">
              <span class="unit-price">${formatCartMoney(originalPrice, cart.currency)}</span>
              <span class="price-label">${escapeHtml(window.themeStrings?.cart_each || 'each')}</span>
            </span>
          </div>
        </div>

        <div class="item-actions-column">
          <div class="quantity-wrapper">
            <label class="quantity-label">${escapeHtml(window.themeStrings?.cart_quantity || 'Quantity')}</label>
            <div class="quantity-controls">
              <button
                type="button"
                class="quantity-btn quantity-decrease"
                data-key="${item.key}"
                ${item.quantity <= 1 ? 'disabled' : ''}
              >
                −
              </button>
              <span class="qty-display" data-key="${item.key}">${item.quantity}</span>
              <button
                type="button"
                class="quantity-btn quantity-increase"
                data-key="${item.key}"
              >
                +
              </button>
            </div>
            ${hasInventoryLimit 
              ? `` 
              : ''}
          </div>
          
          <div class="total-wrapper">
            <label class="total-label">${escapeHtml(window.themeStrings?.cart_total || 'Total')}</label>
            <div class="item-total-price">${formatCartMoney(originalLinePrice, cart.currency)}</div>
          </div>

          <button class="remove-item-btn" data-key="${item.key}">
            × REMOVE
          </button>
        </div>
      </div>
      `;
        })
        .join('');

      // Add event listeners for quantity buttons
      addQuantityListeners();
    }

    // Add quantity change listeners
    function addQuantityListeners() {
      const decreaseButtons = document.querySelectorAll('.cart-sidebar .quantity-decrease');
      const increaseButtons = document.querySelectorAll('.cart-sidebar .quantity-increase');
      const removeButtons = document.querySelectorAll('.cart-sidebar .remove-item-btn');

      decreaseButtons.forEach((btn) => {
        btn.addEventListener('click', function () {
          const key = this.dataset.key;
          const qtyDisplay = this.parentElement.querySelector('.qty-display');
          const currentQty = parseInt(qtyDisplay.textContent);
          if (currentQty > 1) {
            updateCartItem(key, currentQty - 1);
          }
        });
      });

      increaseButtons.forEach((btn) => {
        btn.addEventListener('click', function () {
          const key = this.dataset.key;
          const qtyDisplay = this.parentElement.querySelector('.qty-display');
          const currentQty = parseInt(qtyDisplay.textContent);
          const newQty = currentQty + 1;

          // Check if we can increase using the same logic as main cart
          // if (canIncreaseQuantity(key, newQty)) {
            updateCartItem(key, newQty);
          // }
        });
      });
      
      removeButtons.forEach((btn) => {
        btn.addEventListener('click', function() {
          const key = this.dataset.key;
          removeCartItem(key);
        });
      });
    }

    // Helper function to check if quantity can be increased (same as main cart)
    function canIncreaseQuantity(key, newQuantity) {
      // Check inventory data first
      const inventoryItem = currentInventoryData[key];
      
      if (inventoryItem && 
          inventoryItem.inventory_management === 'shopify' && 
          inventoryItem.inventory_policy === 'deny' && 
          inventoryItem.inventory_quantity !== null) {
          
        const availableStock = inventoryItem.inventory_quantity;
        
        if (newQuantity > availableStock) {
          const msgTpl = window.themeStrings?.only_x_available || 'Only ___COUNT___ items available in stock.';
          showError(msgTpl.replace('___COUNT___', availableStock));
          return false;
        }
        return true;
      }

      // Fallback to DOM check
      const itemCard = document.querySelector(`.cart-sidebar .cart-item-card[data-key="${key}"]`);
      const stockInfo = itemCard ? itemCard.querySelector('.stock-info') : null;

      if (stockInfo) {
        // Extract available stock from text, language-agnostic: just take the first number
        const stockText = stockInfo.textContent;
        const availableStock = parseInt(stockText.match(/(\d+)/)?.[1]);

        if (availableStock && newQuantity > availableStock) {
          const msgTpl = window.themeStrings?.only_x_available || 'Only ___COUNT___ items available in stock.';
          showError(msgTpl.replace('___COUNT___', availableStock));
          return false;
        }
      }

      return true;
    }

    // Update cart item quantity
    function updateCartItem(key, quantity) {
      const formData = new FormData();
      formData.append('updates[' + key + ']', quantity);

      fetch(cartEndpoint('cart/update.js'), {
        method: 'POST',
        body: formData,
      })
        .then((response) => {
          if (!response.ok) throw new Error('Unable to update cart');
          return response.json();
        })
        .then((cart) => {
          // Update stored cart data first
          currentCartData = cart;
          
          // Re-fetch inventory data to ensure it's up to date (optional but safer)
          fetch(cartEndpoint('?section_id=cart-inventory'))
            .then(res => {
              if (!res.ok) throw new Error('Unable to load inventory');
              return res.text();
            })
            .then(inventoryHtml => {
              const parser = new DOMParser();
              const doc = parser.parseFromString(inventoryHtml, 'text/html');
              const inventoryJson = doc.getElementById('inventory-data')?.textContent;
              if (inventoryJson) {
                try {
                  const data = JSON.parse(inventoryJson);
                  currentInventoryData = data.items || {};
                } catch (e) { console.error(e); }
              }
              
              renderCartItems(cart);
              updateCartCount(cart.item_count);
              updateCartTotal(cart);
            });

          // Broadcast cart update event for main cart page
          window.dispatchEvent(
            new CustomEvent('cartUpdated', {
              detail: { cart: cart, source: 'sidebar' },
            })
          );
        })
        .catch((error) => {
          console.error('Error updating cart:', error);
        });
    }

    // Remove cart item
    function removeCartItem(key) {
      updateCartItem(key, 0);
    }

    // Update cart count in header
    function updateCartCount(count) {
      [cartCount, mobileCartCount].forEach(el => {
        if (!el) return;
        if (count > 0) {
          el.textContent = count;
          el.classList.add('cart-count--visible');
        } else {
          el.textContent = '';
          el.classList.remove('cart-count--visible');
        }
      });
    }

    // Update cart total
    function updateCartTotal(cart) {
      const originalSubtotal = cart.items.reduce((total, item) => {
        const originalPrice = Number(item.original_price ?? item.price ?? 0);
        return total + Number(item.original_line_price ?? originalPrice * item.quantity);
      }, 0);
      cartTotal.textContent = formatCartMoney(originalSubtotal, cart.currency);
    }

    function formatCartMoney(amount, currency) {
      const resolvedCurrency = currency || window.themeMoney?.currency || 'EUR';
      const locale = window.themeMoney?.locale || document.documentElement.lang || undefined;
      try {
        return new Intl.NumberFormat(locale, {
          style: 'currency',
          currency: resolvedCurrency,
          currencyDisplay: 'code'
        }).format(Number(amount || 0) / 100);
      } catch (_) {
        return `${resolvedCurrency} ${(Number(amount || 0) / 100).toFixed(2)}`;
      }
    }

    // Show error notification
    window.showError = function(message) {
      // Create a simple error notification
      const errorDiv = document.createElement('div');
      errorDiv.className = 'notification-toast notification-toast-error';
      errorDiv.textContent = message;

      document.body.appendChild(errorDiv);

      setTimeout(() => {
        errorDiv.style.animation = 'slideOutRight 0.3s ease';
        setTimeout(() => {
          if (document.body.contains(errorDiv)) {
            document.body.removeChild(errorDiv);
          }
        }, 300);
      }, 3000);
    }

    // Shared cart additions. Shopify remains the authority for inventory and prices.
    const cartRoot = window.Shopify?.routes?.root || '/';
    const cartEndpoint = (path) => `${cartRoot.replace(/\/?$/, '/')}${path.replace(/^\//, '')}`;
    const responseError = async (response, fallback) => {
      let payload = null;
      try { payload = await response.json(); } catch (_) {}
      return new Error(payload?.description || payload?.message || fallback);
    };

    async function addItemsAndRefresh(request, source) {
      if (window.loadingScreen) window.loadingScreen.show();
      try {
        const response = await fetch(cartEndpoint('cart/add.js'), request);
        if (!response.ok) throw await responseError(response, window.themeStrings?.error_adding_to_cart || 'Unable to add this item to the cart.');
        await response.json();

        const cartResponse = await fetch(cartEndpoint('cart.js'));
        if (!cartResponse.ok) {
          const error = await responseError(cartResponse, window.themeStrings?.cart_refresh_failed || 'Item added, but the cart could not be refreshed. Reload the page before trying again.');
          error.added = true;
          throw error;
        }
        const cart = await cartResponse.json();
        currentCartData = cart;
        updateCartCount(cart.item_count);
        window.dispatchEvent(new CustomEvent('cartUpdated', { detail: { cart, source } }));
        return cart;
      } finally {
        if (window.loadingScreen) window.loadingScreen.hide();
      }
    }

    window.addToCartAndUpdate = function (formData, source = 'quick-add') {
      return addItemsAndRefresh({ method: 'POST', body: formData }, source);
    };

    window.addItemsToCartAndUpdate = function (items, source = 'quick-add') {
      return addItemsAndRefresh({
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items })
      }, source);
    };

    // Clear Cart Modal Functionality
    const clearCartBtn = document.getElementById('clear-cart-btn');
    const clearCartModal = document.getElementById('clear-cart-modal');
    const modalOverlay = document.getElementById('modal-overlay');
    const modalCancel = document.getElementById('modal-cancel');
    const modalConfirm = document.getElementById('modal-confirm');

    // Open modal
    if (clearCartBtn) {
      clearCartBtn.addEventListener('click', function () {
        clearCartModal.classList.add('open');
        modalOverlay.classList.add('open');
      });
    }

    // Close modal
    function closeModal() {
      clearCartModal.classList.remove('open');
      modalOverlay.classList.remove('open');
    }

    if (modalCancel) {
      modalCancel.addEventListener('click', closeModal);
    }

    if (modalOverlay) {
      modalOverlay.addEventListener('click', closeModal);
    }

    // Confirm clear cart
    if (modalConfirm) {
      modalConfirm.addEventListener('click', function () {
        // Clear cart via Shopify API
        fetch(cartEndpoint('cart/clear.js'), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
        })
          .then((response) => {
            if (response.ok) {
              // Update UI immediately
              updateCartCount(0);
              cartItems.innerHTML =
                '<p style="color: #cccccc; text-align: center; padding: 40px;">' +
                (window.themeStrings?.cart_empty_title || 'Your cart is empty') +
                '</p>';
              cartTotal.textContent = formatCartMoney(0, currentCartData?.currency);

              // Broadcast cart clear event for main cart page
              window.dispatchEvent(
                new CustomEvent('cartCleared', {
                  detail: { source: 'sidebar' },
                })
              );

              // Close modal and cart
              closeModal();
              closeCart();
            } else {
              throw new Error('Failed to clear cart');
            }
          })
          .catch((error) => {
            closeModal();
          });
      });
    }

    // Listen for cart updates from main cart page
    window.addEventListener('cartUpdated', function (event) {
      if (event.detail.source !== 'sidebar') {
        const cart = event.detail.cart;

        // Update stored cart data
        currentCartData = cart;

        updateCartCount(cart.item_count);
        updateCartTotal(cart);

        // If sidebar is open, refresh the items
        if (cartSidebar.classList.contains('open')) {
          renderCartItems(cart);
        }
      }
    });

    // Listen for cart clear events from main cart page
    window.addEventListener('cartCleared', function (event) {
      if (event.detail.source !== 'sidebar') {
        updateCartCount(0);
        cartTotal.textContent = formatCartMoney(0, currentCartData?.currency);

        // If sidebar is open, show empty state
        if (cartSidebar.classList.contains('open')) {
          cartItems.innerHTML = '<p style="color: #cccccc; text-align: center; padding: 40px;">Your cart is empty</p>';
        }
      }
    });

    // Header inline search dropdown
    const inlineSearch = document.querySelector('[data-search]');
    const inlineSearchToggle = inlineSearch?.querySelector('.header-search-toggle');
    const inlineSearchInput = inlineSearch?.querySelector('.header-search-input');
    const inlineSearchForm = inlineSearch?.querySelector('form');

    const closeInlineSearch = () => {
      if (!inlineSearch) return;
      inlineSearch.classList.remove('is-open');
      document.body.classList.remove('search-open');
      inlineSearchToggle?.setAttribute('aria-expanded', 'false');
    };

    const openInlineSearch = () => {
      if (!inlineSearch) return;
      inlineSearch.classList.add('is-open');
      document.body.classList.add('search-open');
      inlineSearchToggle?.setAttribute('aria-expanded', 'true');
      requestAnimationFrame(() => inlineSearchInput?.focus());
    };

    inlineSearchToggle?.addEventListener('click', (event) => {
      event.stopPropagation();
      if (inlineSearch?.classList.contains('is-open')) {
        closeInlineSearch();
      } else {
        openInlineSearch();
      }
    });

    inlineSearchForm?.addEventListener('click', (event) => {
      event.stopPropagation();
    });

    document.addEventListener('click', (event) => {
      if (!inlineSearch) return;
      if (!inlineSearch.contains(event.target)) {
        closeInlineSearch();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeInlineSearch();
      }
    });

    inlineSearchForm?.addEventListener('submit', () => {
      closeInlineSearch();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Size Guide Popup - Click to toggle on mobile/tablet, hover on desktop
  const sizeGuideInfoBtn = document.querySelector('.size-guide-info-btn');
  const sizeGuidePopup = document.querySelector('.size-guide-popup');
  const sizeGuideClose = document.querySelector('.size-guide-close');
  
  if (sizeGuideInfoBtn && sizeGuidePopup) {
    // Click handler for info button
    sizeGuideInfoBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      sizeGuidePopup.classList.toggle('active');
    });
    
    // Close button handler
    if (sizeGuideClose) {
      sizeGuideClose.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        sizeGuidePopup.classList.remove('active');
      });
    }
    
    // Close popup when clicking outside
    document.addEventListener('click', function(e) {
      if (!sizeGuidePopup.contains(e.target) && !sizeGuideInfoBtn.contains(e.target)) {
        sizeGuidePopup.classList.remove('active');
      }
    });
    
    // Close on escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        sizeGuidePopup.classList.remove('active');
      }
    });

    // Unit toggle handler (CM / IN)
    const unitBtns = document.querySelectorAll('.unit-btn');
    unitBtns.forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        const unit = this.dataset.unit;
        unitBtns.forEach(b => b.classList.remove('active'));
        this.classList.add('active');

        const tables = document.querySelectorAll('.size-guide-table');
        tables.forEach(t => {
          if (t.dataset.unit === unit) {
            t.style.display = '';
          } else {
            t.style.display = 'none';
          }
        });
      });
    });
  }

  // Fullscreen image gallery with smooth scroll capture
  const gallery = document.getElementById('product-gallery');
  const imagesContainer = document.getElementById('product-images-fullscreen');
  const thumbnails = document.querySelectorAll('.thumbnail');
  const fullscreenImages = document.querySelectorAll('.fullscreen-image');
  let isGalleryScrolling = true;
  let scrollTimeout = null;
  
  // Smooth scroll to image with easing
  function smoothScrollToImage(targetImage) {
    if (!targetImage || !imagesContainer) return;
    
    if (window.innerWidth <= 768) {
      const targetLeft = targetImage.offsetLeft;
      imagesContainer.scrollTo({
        left: targetLeft,
        behavior: 'smooth'
      });
    } else {
      const targetTop = targetImage.offsetTop;
      imagesContainer.scrollTo({
        top: targetTop,
        behavior: 'smooth'
      });
    }
  }
  
  // Thumbnail click scrolls to image
  thumbnails.forEach(thumb => {
    thumb.addEventListener('click', function() {
      const index = this.dataset.imageIndex;
      const targetImage = document.querySelector(`.fullscreen-image[data-image-index="${index}"]`);
      smoothScrollToImage(targetImage);
    });
  });
  
  // Intersection Observer to update active thumbnail
  if (imagesContainer && fullscreenImages.length > 0) {
    const observerOptions = {
      root: imagesContainer,
      rootMargin: '0px',
      threshold: 0.5
    };
    
    const imageObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const index = entry.target.dataset.imageIndex;
          thumbnails.forEach(t => t.classList.remove('active'));
          const activeThumb = document.querySelector(`.thumbnail[data-image-index="${index}"]`);
          if (activeThumb) {
            activeThumb.classList.add('active');
            if (window.innerWidth <= 768 && activeThumb.scrollIntoView) {
              activeThumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
            }
          }
          
          // Check if we're at the last image on desktop
          if (window.innerWidth > 768) {
            const lastIndex = fullscreenImages.length - 1;
            if (parseInt(index) === lastIndex) {
              // Small delay to allow animation to complete
              clearTimeout(scrollTimeout);
              scrollTimeout = setTimeout(() => {
                const scrolledToBottom = imagesContainer.scrollHeight - imagesContainer.scrollTop <= imagesContainer.clientHeight + 20;
                if (scrolledToBottom) {
                  isGalleryScrolling = false;
                }
              }, 100);
            }
          }
        }
      });
    }, observerOptions);
    
    fullscreenImages.forEach(img => imageObserver.observe(img));
    
    // Capture scroll on gallery until all images viewed - smoother wheel handling
    if (gallery) {
      let accumulatedDelta = 0;
      let lastScrollTime = 0;

      if (window.innerWidth <= 768) {
        isGalleryScrolling = false;
      }
      
      gallery.addEventListener('wheel', function(e) {
        if (window.innerWidth <= 768) return;
        const now = Date.now();
        
        if (isGalleryScrolling) {
          // Check if at the end
          const atBottom = imagesContainer.scrollHeight - imagesContainer.scrollTop <= imagesContainer.clientHeight + 10;
          const atTop = imagesContainer.scrollTop <= 10;
          
          if (e.deltaY > 0 && atBottom) {
            isGalleryScrolling = false;
            return; // Allow page scroll
          }
          if (e.deltaY < 0 && atTop) {
            return; // Allow page scroll up
          }
          
          e.preventDefault();
          
          // Accumulate delta for smoother scrolling
          if (now - lastScrollTime > 50) {
            accumulatedDelta = 0;
          }
          accumulatedDelta += e.deltaY;
          lastScrollTime = now;
          
          // Apply scroll with momentum feel
          imagesContainer.scrollBy({ 
            top: e.deltaY * 1.2, 
            behavior: 'auto' 
          });
        } else {
          // Re-enable gallery scroll if scrolling back up into view
          const rect = gallery.getBoundingClientRect();
          if (rect.top >= -50 && e.deltaY < 0) {
            isGalleryScrolling = true;
            e.preventDefault();
            imagesContainer.scrollTo({
              top: imagesContainer.scrollHeight - imagesContainer.clientHeight,
              behavior: 'auto'
            });
          }
        }
      }, { passive: false });
      
      // Touch support for desktop/tablet vertical capture
      if (window.innerWidth > 768) {
        let touchStartY = 0;
        let touchStartScrollTop = 0;
        
        gallery.addEventListener('touchstart', function(e) {
          touchStartY = e.touches[0].clientY;
          touchStartScrollTop = imagesContainer.scrollTop;
        }, { passive: true });
        
        gallery.addEventListener('touchmove', function(e) {
          if (!isGalleryScrolling) return;

          const touchY = e.touches[0].clientY;
          const deltaY = touchStartY - touchY;

          const atBottom = imagesContainer.scrollHeight - imagesContainer.scrollTop <= imagesContainer.clientHeight + 10;
          const atTop = imagesContainer.scrollTop <= 10;

          if (deltaY > 0 && atBottom) {
            isGalleryScrolling = false;
            return;
          }
          if (deltaY < 0 && atTop) {
            return;
          }
        }, { passive: true });
      }
    }
  }
  
  // Size Guide Unit Toggle
  const unitBtns = document.querySelectorAll('.unit-btn');
  unitBtns.forEach(btn => {
    btn.addEventListener('click', function() {
      const unit = this.dataset.unit;
      unitBtns.forEach(b => b.classList.remove('active'));
      this.classList.add('active');
      
      document.querySelectorAll('.size-guide-table').forEach(table => {
        table.style.display = table.dataset.unit === unit ? 'block' : 'none';
      });
    });
  });
  
  // Lightbox
  const lightbox = document.getElementById('image-lightbox');
  const lightboxImage = document.getElementById('lightbox-image');
  const lightboxClose = document.querySelector('.lightbox-close');
  const lightboxPrev = document.querySelector('.lightbox-prev');
  const lightboxNext = document.querySelector('.lightbox-next');
  let currentLightboxIndex = 0;
  
  if (imagesContainer && lightbox) {
    imagesContainer.addEventListener('click', function(e) {
      if (e.target.tagName === 'IMG') {
        const zoomSrc = e.target.dataset.zoomSrc || e.target.src;
        lightboxImage.src = zoomSrc;
        lightboxImage.alt = e.target.alt;
        currentLightboxIndex = parseInt(e.target.closest('.fullscreen-image').dataset.imageIndex);
        lightbox.classList.add('active');
        document.body.style.overflow = 'hidden';
      }
    });
    
    lightboxClose.addEventListener('click', closeLightbox);
    lightbox.addEventListener('click', function(e) {
      if (e.target === lightbox) closeLightbox();
    });
    
    function closeLightbox() {
      lightbox.classList.remove('active');
      document.body.style.overflow = '';
    }
    
    lightboxPrev.addEventListener('click', function() {
      const images = document.querySelectorAll('.fullscreen-image img');
      currentLightboxIndex = (currentLightboxIndex - 1 + images.length) % images.length;
      const img = images[currentLightboxIndex];
      lightboxImage.src = img.dataset.zoomSrc || img.src;
    });
    
    lightboxNext.addEventListener('click', function() {
      const images = document.querySelectorAll('.fullscreen-image img');
      currentLightboxIndex = (currentLightboxIndex + 1) % images.length;
      const img = images[currentLightboxIndex];
      lightboxImage.src = img.dataset.zoomSrc || img.src;
    });
    
    document.addEventListener('keydown', function(e) {
      if (!lightbox.classList.contains('active')) return;
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowLeft') lightboxPrev.click();
      if (e.key === 'ArrowRight') lightboxNext.click();
    });
  }
  
  // Commerce state: variant availability, drop messages and safe cart adds.
  const commerceRoot = document.querySelector('[data-product-commerce]');
  const variantDataEl = document.getElementById('variant-data');
  if (!commerceRoot || !variantDataEl) return;

  const variantData = JSON.parse(variantDataEl.textContent);
  const productForm = commerceRoot.querySelector('form[action*="/cart/add"]');
  const variantSelector = commerceRoot.querySelector('.variant-selector');
  const priceEl = document.querySelector('.product-price');
  const btnPriceEl = commerceRoot.querySelector('.btn-price');
  const addToCartBtn = commerceRoot.querySelector('#add-to-cart-btn');
  const stockStatus = commerceRoot.querySelector('[data-stock-status]');
  const lowStockEl = commerceRoot.querySelector('[data-low-stock]');
  const extinctEl = commerceRoot.querySelector('[data-extinct]');
  const cartMessage = commerceRoot.querySelector('.cart-message');
  const optionInputs = Array.from(commerceRoot.querySelectorAll('input[data-option-position]'));
  const normalise = (value) => String(value || '').trim().toLocaleLowerCase();
  const optionValue = (variant, position) => variant[`option${position}`];

  function selectedOptions() {
    const values = {};
    optionInputs.filter(input => input.checked).forEach(input => {
      values[Number(input.dataset.optionPosition)] = normalise(input.value);
    });
    return values;
  }

  function matchingVariant(values) {
    return variantData.variants.find(variant => Object.entries(values).every(([position, value]) => normalise(optionValue(variant, position)) === value));
  }

  function isControlAvailable(input, values) {
    const position = Number(input.dataset.optionPosition);
    const proposed = { ...values, [position]: normalise(input.value) };
    return variantData.variants.some(variant => variant.available && Object.entries(proposed).every(([key, value]) => normalise(optionValue(variant, key)) === value));
  }

  function isSizeInput(input) {
    return /size|tamanho/i.test(input.dataset.optionName || '');
  }

  function setMessage(element, message, visible, className) {
    if (!element) return;
    if (message !== undefined) element.textContent = message;
    element.hidden = !visible;
    if (className) element.className = className;
  }

  function updateBundle(values) {
    const card = commerceRoot.querySelector('[data-drop-bundle-card]');
    if (!card) return;
    const productId = Number(commerceRoot.dataset.productId);
    const productHandle = commerceRoot.dataset.productHandle;
    const compOneId = Number(card.dataset.componentOneId);
    const compTwoId = Number(card.dataset.componentTwoId);
    const compOneHandle = card.dataset.componentOneHandle;
    const compTwoHandle = card.dataset.componentTwoHandle;

    const isCompOne = (productId && compOneId && productId === compOneId) || (productHandle && compOneHandle && productHandle === compOneHandle);
    const isCompTwo = (productId && compTwoId && productId === compTwoId) || (productHandle && compTwoHandle && productHandle === compTwoHandle);

    const mainSizePosition = variantData.options.findIndex(option => /size|tamanho/i.test(option.name)) + 1;
    const size = values[mainSizePosition];
    if (!size) return;

    let targetSelect = null;
    if (isCompOne) {
      targetSelect = card.querySelector('[data-drop-bundle-size="one"]');
    } else if (isCompTwo) {
      targetSelect = card.querySelector('[data-drop-bundle-size="two"]');
    }

    if (targetSelect && normalise(targetSelect.value) !== size) {
      const matchingOption = Array.from(targetSelect.options).find(opt => normalise(opt.value) === size);
      if (matchingOption) {
        targetSelect.value = matchingOption.value;
        targetSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }

  function updateVariant() {
    const values = selectedOptions();
    const variant = matchingVariant(values);
    optionInputs.forEach(input => {
      const available = isControlAvailable(input, values);
      input.disabled = !available && !input.checked && !isSizeInput(input);
      input.closest('label')?.classList.toggle('is-extinct', !available);
      input.closest('label')?.setAttribute('aria-disabled', String(!available));
    });

    updateBundle(values);

    if (!variant) {
      if (variantSelector) variantSelector.value = '';
      if (addToCartBtn) addToCartBtn.disabled = true;
      setMessage(stockStatus, window.themeStrings?.sold_out || 'Sold out', true, 'stock-status out-stock');
      setMessage(extinctEl, undefined, false);
      setMessage(lowStockEl, undefined, false);
      return;
    }

    if (variantSelector) variantSelector.value = variant.id;
    if (priceEl) priceEl.innerHTML = variant.priceHtml;
    if (btnPriceEl) btnPriceEl.innerHTML = variant.priceHtml;
    if (addToCartBtn) {
      addToCartBtn.disabled = !variant.available;
      const text = addToCartBtn.querySelector('.btn-text');
      if (text) text.textContent = variant.available ? (window.themeStrings?.add_to_cart || 'Add to Cart') : (window.themeStrings?.sold_out || 'Sold out');
    }

    const selectedSizeOutOfStock = optionInputs.some(input => input.checked && isSizeInput(input)) && !variant.available;
    setMessage(stockStatus, window.themeStrings?.sold_out || 'Sold out', !variant.available && !selectedSizeOutOfStock, 'stock-status out-stock');
    setMessage(extinctEl, undefined, selectedSizeOutOfStock);
    const initialStock = Number(variant.drop_initial_stock);
    const ratioLimit = Number(commerceRoot.dataset.lowStockRatio || 67) / 100;
    const isLowStock = commerceRoot.dataset.lowStockEnabled === 'true'
      && variant.available
      && variant.inventory_management === 'shopify'
      && variant.inventory_policy === 'deny'
      && Number.isFinite(initialStock)
      && initialStock > 0
      && Number(variant.inventory_quantity) > 0
      && Number(variant.inventory_quantity) / initialStock <= ratioLimit;
    setMessage(lowStockEl, undefined, isLowStock);
  }

  optionInputs.forEach(input => input.addEventListener('change', updateVariant));
  updateVariant();

  function showCartMessage(message, isError) {
    if (!cartMessage) return;
    cartMessage.className = `cart-message ${isError ? 'error' : 'success'}`;
    cartMessage.textContent = message;
    cartMessage.style.display = 'block';
  }

  if (productForm) {
    productForm.addEventListener('submit', async event => {
      event.preventDefault();
      if (!variantSelector?.value || !addToCartBtn || addToCartBtn.disabled) return;
      const buttonText = addToCartBtn.querySelector('.btn-text');
      const previousText = buttonText?.textContent;
      addToCartBtn.disabled = true;
      if (buttonText) buttonText.textContent = window.themeStrings?.adding || 'Adding...';
      try {
        const formData = new FormData(productForm);
        if (!window.addToCartAndUpdate) throw new Error('Cart service unavailable');
        await window.addToCartAndUpdate(formData, 'product');
        showCartMessage(window.themeStrings?.added_to_cart || 'Added to cart!', false);
      } catch (error) {
        showCartMessage(error.added ? (window.themeStrings?.cart_refresh_failed || error.message) : (error.message || window.themeStrings?.error_adding_to_cart || 'Error adding to cart.'), true);
      } finally {
        updateVariant();
        if (buttonText && !addToCartBtn.disabled) buttonText.textContent = previousText || window.themeStrings?.add_to_cart || 'Add to Cart';
      }
    });
  }

  commerceRoot.querySelector('[data-bundle-add]')?.addEventListener('click', async event => {
    const button = event.currentTarget;
    const variantId = Number(button.dataset.variantId);
    if (!variantId || button.disabled) return;
    const status = commerceRoot.querySelector('[data-bundle-status]');
    button.disabled = true;
    try {
      if (!window.addItemsToCartAndUpdate) throw new Error('Cart service unavailable');
      await window.addItemsToCartAndUpdate([{ id: variantId, quantity: 1 }], 'bundle');
      setMessage(status, window.themeStrings?.added_to_cart || 'Added to cart!', true);
    } catch (error) {
      setMessage(status, error.message || window.themeStrings?.error_adding_to_cart || 'Error adding to cart.', true);
    } finally {
      updateVariant();
    }
  });

  function zonedParts(timeZone) {
    const parts = new Intl.DateTimeFormat('en-GB', { timeZone, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' }).formatToParts(new Date());
    return Object.fromEntries(parts.filter(part => part.type !== 'literal').map(part => [part.type, Number(part.value)]));
  }

  function initialiseDeliveryEstimate() {
    const estimate = commerceRoot.querySelector('[data-delivery-estimate]');
    if (!estimate) return;
    const weekdays = new Set((estimate.dataset.weekdays || '1,2,3,4,5').split(',').map(Number));
    const closedDates = new Set((estimate.dataset.closedDates || '').split(/[\n,]+/).map(value => value.trim()).filter(Boolean));
    const [cutoffHour, cutoffMinute] = (estimate.dataset.cutoff || '15:00').split(':').map(Number);
    const timeZone = estimate.dataset.timezone || 'Europe/Lisbon';
    const isBusinessDay = date => weekdays.has(((date.getUTCDay() + 6) % 7) + 1) && !closedDates.has(date.toISOString().slice(0, 10));
    const nextBusinessDate = (date, offset = 0) => {
      const result = new Date(date);
      result.setUTCDate(result.getUTCDate() + offset);
      while (!isBusinessDay(result)) result.setUTCDate(result.getUTCDate() + 1);
      return result;
    };
    const displayDate = date => new Intl.DateTimeFormat(document.documentElement.lang || undefined, { timeZone: 'UTC', weekday: 'long', day: 'numeric', month: 'long' }).format(date);
    const render = () => {
      try {
        const now = zonedParts(timeZone);
        const base = new Date(Date.UTC(now.year, now.month - 1, now.day));
        const secondsUntilCutoff = (cutoffHour * 3600 + cutoffMinute * 60) - (now.hour * 3600 + now.minute * 60 + (now.second || 0));
        const todayIsBusinessDay = isBusinessDay(base);
        const beforeCutoff = todayIsBusinessDay && secondsUntilCutoff > 0;
        const dispatch = nextBusinessDate(base, beforeCutoff ? 0 : 1);
        const from = nextBusinessDate(dispatch, Number(estimate.dataset.minDays || 1));
        const to = nextBusinessDate(dispatch, Number(estimate.dataset.maxDays || 3));
        let dispatchText;
        if (beforeCutoff) {
          const remainingMinutes = Math.ceil(secondsUntilCutoff / 60);
          const hours = Math.floor(remainingMinutes / 60);
          const minutes = remainingMinutes % 60;
          const time = `${hours}h ${minutes}m`;
          dispatchText = (estimate.dataset.countdownTemplate || '').replace('___TIME___', time).replace('___DAY___', displayDate(dispatch));
        } else {
          const template = estimate.dataset.afterCutoffTemplate || estimate.dataset.countdownTemplate || '';
          dispatchText = template.replace('___DAY___', displayDate(dispatch)).replace('___TIME___', '').trim();
        }
        const arrival = (estimate.dataset.estimateTemplate || '').replace('___CARRIER___', estimate.dataset.carrier).replace('___FROM___', displayDate(from)).replace('___TO___', displayDate(to));
        estimate.textContent = `${dispatchText} ${arrival}`.trim();
      } catch (_) {
        estimate.hidden = true;
      }
    };
    render();
    window.setInterval(render, 60000);
  }

  function initialiseDropCountdown() {
    const countdown = commerceRoot.querySelector('[data-drop-countdown]');
    if (!countdown) return;
    const endAt = Date.parse(countdown.dataset.endAt);
    if (Number.isNaN(endAt)) { countdown.hidden = true; return; }
    const render = () => {
      const remaining = Math.max(0, endAt - Date.now());
      if (remaining === 0) {
        countdown.textContent = countdown.dataset.endedText;
        countdown.classList.add('is-ended');
        return;
      }
      const totalMinutes = Math.floor(remaining / 60000);
      const days = Math.floor(totalMinutes / 1440);
      const hours = Math.floor((totalMinutes % 1440) / 60);
      const minutes = totalMinutes % 60;
      countdown.textContent = countdown.dataset.countdownTemplate.replace('___DROP___', countdown.dataset.dropName).replace('___DAYS___', days).replace('___HOURS___', hours).replace('___MINUTES___', minutes);
    };
    render();
    window.setInterval(render, 60000);
  }

  initialiseDeliveryEstimate();
  initialiseDropCountdown();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sidebar-navigation"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const sidebar = document.getElementById('sidebar');
    const sidebarToggles = document.querySelectorAll('.sidebar-toggle--in-header');
    const sidebarClose = document.getElementById('sidebar-close');
    const sidebarOverlay = document.getElementById('sidebar-overlay');

    const setExpanded = (expanded) => {
      for (const btn of sidebarToggles) {
        btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        btn.classList.toggle('is-active', !!expanded);
      }
    };

    function openSidebar() {
      if (!sidebar) return;
      sidebar.classList.add('open');
      sidebarOverlay?.classList.add('active');
      document.body.style.overflow = 'hidden';
      setExpanded(true);
    }

    function closeSidebar() {
      if (!sidebar) return;
      sidebar.classList.remove('open');
      sidebarOverlay?.classList.remove('active');
      document.body.style.overflow = '';
      setExpanded(false);
    }

    // Initialize ARIA attributes and bind toggles
    if (sidebarToggles && sidebarToggles.length) {
      for (const btn of sidebarToggles) {
        btn.setAttribute('aria-controls', 'sidebar');
        btn.setAttribute('aria-expanded', 'false');
        btn.addEventListener('click', () => {
          if (sidebar?.classList.contains('open')) closeSidebar();
          else openSidebar();
        });
      }
    }

    if (sidebarClose) sidebarClose.addEventListener('click', closeSidebar);
    if (sidebarOverlay) sidebarOverlay.addEventListener('click', closeSidebar);

    // Close sidebar on escape key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && sidebar && sidebar.classList.contains('open')) {
        closeSidebar();
      }
    });

    // Auto-close overlay when resizing to desktop (burger disappears)
    const mqMobile = window.matchMedia('(max-width: 770px)');
    const onViewportChange = (e) => {
      if (!e.matches) {
        // Now desktop: ensure sidebar state is closed and overlay hidden
        closeSidebar();
      }
    };
    // Bind listener with cross-browser support
    if (typeof mqMobile.addEventListener === 'function') {
      mqMobile.addEventListener('change', onViewportChange);
    } else if (typeof mqMobile.addListener === 'function') {
      mqMobile.addListener(onViewportChange);
    }
    // Initial guard on load
    if (!mqMobile.matches) {
      closeSidebar();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
